module.exports = __webpack_public_path__ + "assets/img/3_209_big.de4348fb.jpg";